import AdminLayout from "../AdminLayout";
import { useUserHook } from "./hooks/userHook";

const AddUser = () => {
  const {
    register,
    handleSubmit,
    errors,
    watch,
    currentStep,
    steps,
    handleNextButton,
    handleBackButton,
    formValues,
    stepFormData,
    departmentArr,
    designationArr,
    rolesArr,
    resetStepsFromStart,
    pincodeData,
    loading,
    city,
    state,
    searchQuery,
    handleSearchQuery,
    handlePincodeSelect,
    handleCreateUser,
  } = useUserHook();

  const password = watch("password");

  return (
    <div>
      <AdminLayout>
        <div className="add_user_wepper">
          <div className="container">
            <div className="row">
              {/* Sidebar */}
              <div className="col-lg-3">
                <div className="user_information_Wepper">
                  {steps.map((step, index) => (
                    <div
                      key={step.id}
                      className={`user_information_inner ${
                        currentStep >= step.id ? "active" : ""
                      }`}
                    >
                      <div className="user_information_flex">
                        <div
                          className={`active_track ${
                            currentStep >= step.id ? "green" : ""
                          }`}
                        ></div>
                        <p>{step.label}</p>
                      </div>
                      {index < steps.length - 1 && (
                        <div
                          className={`add_user_trick_link ${
                            currentStep > step.id ? "green" : ""
                          }`}
                        ></div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Form Content */}
              <div className="col-lg-9">
                <div className="add_user_about_me_weepr">
                  {currentStep === 1 && (
                    <form id="form-1">
                      <div className="add_user_about_me">
                        <h3>Basic Details</h3>
                        <p>Fill out your basic information</p>
                      </div>
                      <div className="row from_wepper">
                        {/* firstname */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="first_name">
                              First Name{" "}
                              <span className="required_text">*</span>
                            </label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="first_name"
                                className="form-control"
                                placeholder="Jone"
                                required="true"
                                {...register("first_name", {
                                  required: true,
                                })}
                                aria-invalid={
                                  errors.first_name ? "true" : "false"
                                }
                              />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_771_7773)">
                                  <path
                                    d="M12.6667 4.66733C12.6667 7.244 10.5773 9.334 8 9.334C5.42267 9.334 3.33333 7.244 3.33333 4.66733C3.33333 2.08933 5.42267 0 8 0C10.5773 0 12.6667 2.08933 12.6667 4.66733V4.66733ZM11.6013 9.454C10.5973 10.212 9.352 10.6673 8 10.6673C6.64667 10.6673 5.40067 10.2107 4.39533 9.45267C1.68067 10.648 0 14.37 0 16H16C16 14.3847 14.2667 10.6627 11.6013 9.454V9.454Z"
                                    fill="#6F757E"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_771_7773">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            {errors.first_name?.type === "required" && (
                              <p role="alert" className="alert">
                                * First name is required
                              </p>
                            )}
                          </div>
                        </div>

                        {/* last name */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="last_name">Last Name </label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="last_name"
                                className="form-control"
                                placeholder="Smith"
                                required="false"
                                {...register("last_name", {
                                  required: false,
                                })}
                                // aria-invalid={errors.email ? "true" : "false"}
                              />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_771_7773)">
                                  <path
                                    d="M12.6667 4.66733C12.6667 7.244 10.5773 9.334 8 9.334C5.42267 9.334 3.33333 7.244 3.33333 4.66733C3.33333 2.08933 5.42267 0 8 0C10.5773 0 12.6667 2.08933 12.6667 4.66733V4.66733ZM11.6013 9.454C10.5973 10.212 9.352 10.6673 8 10.6673C6.64667 10.6673 5.40067 10.2107 4.39533 9.45267C1.68067 10.648 0 14.37 0 16H16C16 14.3847 14.2667 10.6627 11.6013 9.454V9.454Z"
                                    fill="#6F757E"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_771_7773">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            {errors?.last_name?.type === "required" && (
                              <p role="alert" className="alert">
                                * Last name is required
                              </p>
                            )}
                          </div>
                        </div>

                        {/* phone */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="phone_number">
                              Mobile Number{" "}
                              <span className="required_text">*</span>
                            </label>
                            <div className="add_user_input">
                              <input
                                type="text" // Use text to enforce maxlength since number input ignores it
                                name="phone_number"
                                className="form-control"
                                placeholder="9876543210"
                                maxLength={10}
                                required={true}
                                {...register("phone", {
                                  required: "Phone number is required",
                                  pattern: {
                                    value: /^[6-9]\d{9}$/,
                                    message:
                                      "Phone number must be a valid 10-digit Indian number",
                                  },
                                })}
                                onInput={(e) => {
                                  // Prevent entering non-numeric characters
                                  e.target.value = e.target.value.replace(
                                    /\D/g,
                                    ""
                                  );
                                }}
                              />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M13.3334 15.0807L10.986 10.5507C10.9807 10.5533 9.67002 11.1973 9.61002 11.2247C8.11669 11.9487 5.07736 6.01133 6.53736 5.22867L7.92602 4.54467L5.59736 0L4.19336 0.692667C-0.607975 3.196 7.01536 18.014 11.9267 15.7693C12.0074 15.7327 13.328 15.0833 13.3334 15.0807Z"
                                  fill="#6F757E"
                                />
                              </svg>
                            </div>
                            {errors.phone?.message && (
                              <p role="alert" className="alert">
                                * {errors?.phone?.message}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* email address */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="email_address">
                              Email <span className="required_text">*</span>
                            </label>
                            <div className="add_user_input">
                              <input
                                type="email"
                                name="email_address"
                                className="form-control"
                                placeholder="john@gmail.com"
                                required={true}
                                {...register("email", {
                                  required: "Email is required",
                                  pattern: {
                                    value:
                                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                    message:
                                      "Please enter a valid email address",
                                  },
                                })}
                              />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M8 8.47533L0.01 2H15.99L8 8.47533ZM8 10.1913L0 3.708V14H16V3.708L8 10.1913Z"
                                  fill="#6F757E"
                                />
                              </svg>
                            </div>
                            {errors?.email && (
                              <p role="alert" className="alert">
                                * {errors?.email?.message}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* birthDate */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="birth_date">
                              Birth day
                              <span className="required_text">*</span>
                            </label>
                            <div className="add_user_input">
                              <input
                                type="date"
                                name="birth_date"
                                className="form-control"
                                placeholder="Finance"
                                required="true"
                                {...register("birth_date", {
                                  required: true,
                                })}
                              />
                              {/* <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_771_2040)">
                                  <path
                                    d="M14 8.6665V15.3332H10V11.3332H6V15.3332H2V8.6665H0L8 0.666504L16 8.6665H14ZM13.3333 4.7285V1.33317H11.3333V2.7285L13.3333 4.7285Z"
                                    fill="#6F757E"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_771_2040">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg> */}
                            </div>
                            {errors.birth_date?.type === "required" && (
                              <p role="alert" className="alert">
                                * Birth date is required
                              </p>
                            )}
                          </div>
                        </div>

                        {/* department */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="department">
                              Department
                              <span className="required_text">*</span>
                            </label>
                            <div className="add_user_input">
                              <select
                                name="department"
                                id="department"
                                className="form-control"
                                {...register("department", {
                                  required: true,
                                  defaultValue: "",
                                })}
                              >
                                <option value="" disabled>
                                  Select Department
                                </option>
                                {departmentArr.map((department) => (
                                  <option
                                    key={department.value}
                                    value={department.value}
                                  >
                                    {department.label}
                                  </option>
                                ))}
                              </select>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_771_2040)">
                                  <path
                                    d="M14 8.6665V15.3332H10V11.3332H6V15.3332H2V8.6665H0L8 0.666504L16 8.6665H14ZM13.3333 4.7285V1.33317H11.3333V2.7285L13.3333 4.7285Z"
                                    fill="#6F757E"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_771_2040">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            {errors.department?.type === "required" && (
                              <p role="alert" className="alert">
                                * Department is required
                              </p>
                            )}
                          </div>
                        </div>

                        {/* designation */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="designation">
                              Designation
                              <span className="required_text">*</span>
                            </label>
                            <div className="add_user_input">
                              <select
                                name="department"
                                id="designation"
                                className="form-control"
                                {...register("designation", {
                                  required: true,
                                  defaultValue: "",
                                })}
                              >
                                <option value="" disabled>
                                  Select Designation
                                </option>
                                {designationArr.map((designation) => (
                                  <option
                                    key={designation.value}
                                    value={designation.value}
                                  >
                                    {designation.label}
                                  </option>
                                ))}
                              </select>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_771_2040)">
                                  <path
                                    d="M14 8.6665V15.3332H10V11.3332H6V15.3332H2V8.6665H0L8 0.666504L16 8.6665H14ZM13.3333 4.7285V1.33317H11.3333V2.7285L13.3333 4.7285Z"
                                    fill="#6F757E"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_771_2040">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            {errors.designation?.type === "required" && (
                              <p role="alert" className="alert">
                                * Designation is required
                              </p>
                            )}
                          </div>
                        </div>

                        {/* role */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="role">
                              Role
                              <span className="required_text">*</span>
                            </label>
                            <div className="add_user_input">
                              <select
                                name="department"
                                id="role"
                                className="form-control"
                                {...register("role", {
                                  required: true,
                                  defaultValue: "",
                                })}
                              >
                                <option value="" disabled>
                                  Select Role
                                </option>
                                {rolesArr.map((role) => (
                                  <option key={role.value} value={role.value}>
                                    {role.label}
                                  </option>
                                ))}
                              </select>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_771_2040)">
                                  <path
                                    d="M14 8.6665V15.3332H10V11.3332H6V15.3332H2V8.6665H0L8 0.666504L16 8.6665H14ZM13.3333 4.7285V1.33317H11.3333V2.7285L13.3333 4.7285Z"
                                    fill="#6F757E"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_771_2040">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            {errors.role?.type === "required" && (
                              <p role="alert" className="alert">
                                * Role is required
                              </p>
                            )}
                          </div>
                        </div>

                        {/* password */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="password">
                              Password
                              <span className="required_text">*</span>
                            </label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="password"
                                className="form-control"
                                placeholder="********"
                                required="true"
                                {...register("password", {
                                  required: true,
                                })}
                              />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_771_2049)">
                                  <path
                                    d="M11.3337 6.50733V3.33333C11.3337 1.49267 9.84166 0 8.00033 0C6.15833 0 4.66699 1.49267 4.66699 3.33333V6.50733C3.44899 7.48467 2.66699 8.98333 2.66699 10.6667C2.66699 13.612 5.05499 16 8.00033 16C10.9457 16 13.3337 13.612 13.3337 10.6667C13.3337 8.98333 12.5517 7.48467 11.3337 6.50733ZM8.00033 12C7.26433 12 6.66699 11.4027 6.66699 10.6667C6.66699 9.93067 7.26433 9.33333 8.00033 9.33333C8.73633 9.33333 9.33366 9.93067 9.33366 10.6667C9.33366 11.4027 8.73633 12 8.00033 12ZM10.0003 5.72467C9.38233 5.474 8.70833 5.33333 8.00033 5.33333C7.29233 5.33333 6.61833 5.474 6.00033 5.72467V3.33333C6.00033 2.23067 6.89766 1.33333 8.00033 1.33333C9.10299 1.33333 10.0003 2.23067 10.0003 3.33333V5.72467Z"
                                    fill="#6F757E"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_771_2049">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            {errors.password?.type === "required" && (
                              <p role="alert" className="alert">
                                * Password is required
                              </p>
                            )}
                          </div>
                        </div>

                        {/* repeat password */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="repeat_password">
                              Repeat password
                              <span className="required_text">*</span>
                            </label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="repeat_password"
                                className="form-control"
                                placeholder="********"
                                required="true"
                                {...register("repeat_password", {
                                  required: "* Repeat password is required",
                                  validate: (value) =>
                                    value === password ||
                                    "* Passwords do not match",
                                })}
                              />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_771_2049)">
                                  <path
                                    d="M11.3337 6.50733V3.33333C11.3337 1.49267 9.84166 0 8.00033 0C6.15833 0 4.66699 1.49267 4.66699 3.33333V6.50733C3.44899 7.48467 2.66699 8.98333 2.66699 10.6667C2.66699 13.612 5.05499 16 8.00033 16C10.9457 16 13.3337 13.612 13.3337 10.6667C13.3337 8.98333 12.5517 7.48467 11.3337 6.50733ZM8.00033 12C7.26433 12 6.66699 11.4027 6.66699 10.6667C6.66699 9.93067 7.26433 9.33333 8.00033 9.33333C8.73633 9.33333 9.33366 9.93067 9.33366 10.6667C9.33366 11.4027 8.73633 12 8.00033 12ZM10.0003 5.72467C9.38233 5.474 8.70833 5.33333 8.00033 5.33333C7.29233 5.33333 6.61833 5.474 6.00033 5.72467V3.33333C6.00033 2.23067 6.89766 1.33333 8.00033 1.33333C9.10299 1.33333 10.0003 2.23067 10.0003 3.33333V5.72467Z"
                                    fill="#6F757E"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_771_2049">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            {errors.repeat_password && (
                              <p role="alert" className="alert">
                                {errors.repeat_password.message}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="setp_btn row">
                          <div className="col-lg-6">
                            {currentStep !== 1 && (
                              <p style={{ cursor: "pointer" }}>Back</p>
                            )}
                          </div>
                          <div
                            className="col-lg-6 continue_step"
                            onClick={() => {
                              handleNextButton();
                            }}
                          >
                            <p style={{ cursor: "pointer" }} className="active">
                              Continue
                            </p>
                          </div>
                        </div>
                      </div>
                    </form>
                  )}

                  {currentStep === 2 && (
                    <form onSubmit={handleSubmit(stepFormData)} id="form-2">
                      <div className="add_user_about_me">
                        <h3>Address Details</h3>
                        <p>Fill out your basic information</p>
                      </div>
                      <div className="row from_wepper">
                        {/* address 1 */}
                        <div className="col-lg-12">
                          <div className="form-group ">
                            <label htmlFor="address1">Address 1</label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="address1"
                                id="address1"
                                className="form-control"
                                placeholder="6391 Elgin St. Celina Delaware 1234"
                                required="true"
                                {...register("address1", { required: true })}
                              />
                            </div>
                            {errors.address1?.type === "required" && (
                              <p role="alert" className="alert">
                                * Address 1 is required
                              </p>
                            )}
                          </div>
                        </div>

                        {/* address 2 */}
                        <div className="col-lg-12">
                          <div className="form-group ">
                            <label htmlFor="address2">Address 2</label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="address2"
                                className="form-control"
                                placeholder="6391 Elgin St. Celina Delaware 1234"
                                {...register("address2")}
                              />
                            </div>
                            {errors.address2?.type === "required" && (
                              <p role="alert" className="alert">
                                * Address 2 is required
                              </p>
                            )}
                          </div>
                        </div>

                        {/* pincode */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="pincode">
                              pincode
                              <span className="required_text">*</span>
                            </label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="pincode"
                                id="pincode"
                                className="form-control"
                                placeholder="Enter pincode"
                                value={searchQuery}
                                {...register("pincode", { required: true })}
                                onChange={(e) => handleSearchQuery(e)}
                              />

                              {loading && <p>Loading...</p>}

                              {/* Show a list of options if pincode data is available */}
                              {pincodeData.length > 0 &&
                                searchQuery.length >= 3 && (
                                  <ul className="pincode-suggestions">
                                    {pincodeData.map((pincode) => (
                                      <li
                                        key={pincode.id}
                                        onClick={() =>
                                          handlePincodeSelect(pincode.pincode)
                                        }
                                        className="pincode-option"
                                      >
                                        {pincode.pincode}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                            </div>
                            {errors.pincode?.type === "required" && (
                              <p role="alert" className="alert">
                                * Pincode is required
                              </p>
                            )}
                          </div>
                        </div>

                        {/* city */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="fname">
                              City
                              <span className="required_text">*</span>
                            </label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="city"
                                id="city"
                                className="form-control"
                                placeholder={city}
                                value={city}
                                disabled
                                {...register("city", { required: false })}
                              />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_816_1720)">
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M8.66667 1.33333H10V2.66667H10.6667V15.3333H11.3333V5.33333L15.3333 7.33333V15.3333H16V16H0V15.3333H0.666667V8H5.33333V15.3333H6V2.66667H6.66667V1.33333H8V0H8.66667V1.33333ZM14 15.3333V14H12.6667V15.3333H14ZM4 15.3333V14H2V15.3333H4ZM9.33333 15.3333V14H7.33333V15.3333H9.33333ZM8 12.6667V4H7.33333V12.6667H8ZM14 12.6667V12H12.6667V12.6667H14ZM2 12.6667V11.3333H1.33333V12.6667H2ZM4.66667 12.6667V11.3333H4V12.6667H4.66667ZM3.33333 12.6667V11.3333H2.66667V12.6667H3.33333ZM9.33333 12.6667V4H8.66667V12.6667H9.33333ZM14 11.3333V10.6667H12.6667V11.3333H14ZM2 10.6667V9.33333H1.33333V10.6667H2ZM3.33333 10.6667V9.33333H2.66667V10.6667H3.33333ZM4.66667 10.6667V9.33333H4V10.6667H4.66667ZM14 10V9.33333H12.6667V10H14ZM14 8.574V7.90733H12.6667V8.574H14Z"
                                    fill="#6F757E"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_816_1720">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            {/* {errors.city?.type === "required" && (
                              <p role="alert" className="alert">
                                * City is required
                              </p>
                            )} */}
                          </div>
                        </div>

                        {/* state */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="state">
                              State
                              <span className="required_text">*</span>
                            </label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="state"
                                id="state"
                                className="form-control"
                                placeholder={state}
                                value={state}
                                disabled
                                {...register("state", { required: false })}
                              />
                              {/* {errors.state?.type === "required" && (
                                <p role="alert" className="alert">
                                  * State is required
                                </p>
                              )} */}
                            </div>
                          </div>
                        </div>

                        {/* gender */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="department">
                              Gender
                              <span className="required_text">*</span>
                            </label>
                            <div className="add_user_input">
                              <select
                                name="gender"
                                id="gender"
                                className="form-control"
                                {...register("gender", {
                                  required: true,
                                  defaultValue: "",
                                })}
                              >
                                <option value="" disabled>
                                  Select Gender
                                </option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                              </select>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_771_2040)">
                                  <path
                                    d="M14 8.6665V15.3332H10V11.3332H6V15.3332H2V8.6665H0L8 0.666504L16 8.6665H14ZM13.3333 4.7285V1.33317H11.3333V2.7285L13.3333 4.7285Z"
                                    fill="#6F757E"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_771_2040">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            {errors.gender?.type === "required" && (
                              <p role="alert" className="alert">
                                * gender is required
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="setp_btn row">
                          <div
                            style={{ cursor: "pointer" }}
                            className="col-lg-6"
                            onClick={handleBackButton}
                          >
                            <p>Back</p>
                          </div>
                          <div
                            style={{ cursor: "pointer" }}
                            className="col-lg-6 continue_step"
                            onClick={handleNextButton}
                          >
                            <p className="active">Continue</p>
                          </div>
                        </div>
                      </div>
                    </form>
                  )}

                  {currentStep === 3 && (
                    <form action="" id="form-3">
                      <div className="add_user_about_me">
                        <h3>Profile review</h3>
                        <p>
                          Review all your provided info, Edit if you need to!
                        </p>
                      </div>
                      {/* name and phone */}
                      <div className="row from_wepper">
                        <div className="col-lg-8">
                          <div className="row">
                            <div className="col-lg-4">
                              <div className="profile_review_pic">
                                <img src="images/add-user-profile.png" alt="" />
                              </div>
                            </div>
                            <div className="col-lg-8">
                              <div className="profile_review_wepper">
                                <h4>Name</h4>
                                <p>
                                  {formValues?.first_name}{" "}
                                  {formValues?.last_name}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="profile_review_wepper">
                            <h4>Phone</h4>
                            <p>+91 {formValues?.phone}</p>
                          </div>
                        </div>
                      </div>

                      {/* email & birthdate */}
                      <div className="row from_wepper">
                        <div className="col-lg-8">
                          <div className="row">
                            <div className="col-lg-4"></div>
                            <div className="col-lg-8">
                              <div className="profile_review_wepper">
                                <h4>Email</h4>
                                <p>{formValues?.email}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="profile_review_wepper">
                            <h4>BirthDate</h4>
                            <p>
                              {formValues?.birth_date} {"(YYYY-MM-DD)"}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* department & designation */}
                      <div className="row from_wepper">
                        <div className="col-lg-8">
                          <div className="row">
                            <div className="col-lg-4"></div>
                            <div className="col-lg-8">
                              <div className="profile_review_wepper">
                                <h4>Designation</h4>
                                <p>{formValues?.designation}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="profile_review_wepper">
                            <h4>Department</h4>
                            <p>{formValues?.department}</p>
                          </div>
                        </div>
                      </div>

                      {/* gender & password */}
                      <div className="row from_wepper">
                        <div className="col-lg-8">
                          <div className="row">
                            <div className="col-lg-4"></div>
                            <div className="col-lg-8">
                              <div className="profile_review_wepper">
                                <h4>Gender</h4>
                                <p>{formValues?.gender}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="profile_review_wepper">
                            <h4>Password</h4>
                            <p>{formValues?.password}</p>
                          </div>
                        </div>
                      </div>

                      {/* address 1 & city */}
                      <div className="row from_wepper">
                        <div className="col-lg-8">
                          <div className="row">
                            <div className="col-lg-4"></div>
                            <div className="col-lg-8">
                              <div className="profile_review_wepper">
                                <h4>Address 1</h4>
                                <p>{formValues?.address1}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="profile_review_wepper">
                            <h4>City</h4>
                            <p>{formValues?.city}</p>
                          </div>
                        </div>
                      </div>

                      {/* address 2 & state */}
                      <div className="row from_wepper">
                        <div className="col-lg-8">
                          <div className="row">
                            <div className="col-lg-4"></div>
                            <div className="col-lg-8">
                              <div className="profile_review_wepper">
                                <h4>Address 2</h4>
                                <p>{formValues?.address2}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="profile_review_wepper">
                            <h4>State</h4>
                            <p>{formValues?.state}</p>
                          </div>
                        </div>
                      </div>

                      {/*  role & pincode */}
                      <div className="row from_wepper">
                        <div className="col-lg-8">
                          <div className="row">
                            <div className="col-lg-4"></div>
                            <div className="col-lg-8">
                              <div className="profile_review_wepper">
                                <h4>Admin Role</h4>
                                <p>{formValues?.role}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="profile_review_wepper">
                            <h4>Pincode</h4>
                            <p>{formValues?.pincode}</p>
                          </div>
                        </div>
                      </div>

                      <div className="setp_btn row mt-5 justify-content-end">
                        <div className="col-lg-6">
                          <div className="row">
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={resetStepsFromStart}
                              className="col-lg-6"
                            >
                              <p>Edit info</p>
                            </div>
                            <div
                              style={{ cursor: "pointer" }}
                              className="col-lg-6 continue_step"
                              onClick={handleCreateUser}
                            >
                              <p className="active">Save user</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  )}

                  {/* Add more forms for additional steps */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminLayout>
    </div>
  );
};

export default AddUser;
